import { BatchRequestProcessor } from 'core-utilities';

export enum ThumbnailTypes {
  assetThumbnail = 'assetThumbnail',
  avatarHeadshot = 'avatarHeadshot',
  avatar = 'avatar',
  bundleThumbnail = 'bundleThumbnail',
  gameIcon = 'gameIcon',
  groupIcon = 'groupIcon',
  badgeIcon = 'badgeIcon',
  gamePassIcon = 'gamePassIcon',
  developerProductIcon = 'developerProductIcon',
  userOutfit = 'userOutfit',
  gameThumbnail = 'gameThumbnail'
}

export const DefaultBatchSize = 100;

export enum ThumbnailCooldown {
  maxRetryAttempts = 10,
  minCooldown = 1000,
  maxCooldown = 30000
}

// expand when batchRequestProcessor is implemented
export interface ThumbnailRequesters {
  [key: string]: BatchRequestProcessor;
}

export interface ThumbnailCache {
  [key: string]: object;
}

export const DefaultThumbnailSize = '150x150';

export const DefaultThumbnailFormat = 'png';

export enum ThumbnailGameIconSize {
  size50 = '50x50',
  size150 = '150x150'
}

export enum ThumbnailGamePassIconSize {
  size150 = '150x150'
}

export enum ThumbnailAssetsSize {
  size150 = '150x150',
  size420 = '420x420'
}

export enum ThumbnailAvatarsSize {
  size100 = '100x100',
  size352 = '352x352',
  size720 = '720x720'
}

export enum ThumbnailAvatarHeadshotSize {
  size48 = '48x48',
  size60 = '60x60',
  size150 = '150x150'
}

export enum ThumbnailGroupIconSize {
  size150 = '150x150',
  size420 = '420x420'
}

export enum ThumbnailBadgeIconSize {
  size150 = '150x150'
}

export enum ThumbnailDeveloperProductIconSize {
  size150 = '150x150'
}

export enum ThumbnailGameThumbnailSize {
  width768 = '768x432',
  width576 = '576x324',
  width480 = '480x270',
  width384 = '384x216',
  width256 = '256x144'
}

export enum ThumbnailStates {
  error = 'Error',
  complete = 'Completed',
  inReview = 'InReview',
  pending = 'Pending',
  blocked = 'Blocked'
}

export enum ThumbnailFormat {
  png = 'png'
}

export enum ReturnPolicy {
  PlaceHolder = 'PlaceHolder',
  AutoGenerated = 'AutoGenerated',
  ForceAutoGenerated = 'ForceAutoGenerated'
}

export interface ThumbnailPendingTrackerItem {
  startTime: number;
}

export interface ThumbnailCompleteTrackerItem {
  startTime: number;
}

export interface ThumbnailPendingTracker {
  [key: string]: ThumbnailPendingTrackerItem;
}

export interface ThumbnailCompleteTracker {
  [key: string]: ThumbnailCompleteTrackerItem;
}

export interface ThumbnailDataItem {
  targetId: number;
  state: ThumbnailStates;
}

export interface ThumbnailData {
  data: Array<object>;
}

export interface ThumbnailDataData {
  data: ThumbnailData;
}
